import React, { useState, useContext, useEffect,useRef } from 'react';
import { UserContext } from '../../context/provider/UserProvider';
import Logobeex from '../../assets/images/Logobeex.fw.png'
import styled, { createGlobalStyle } from 'styled-components';
import { ChatProvider } from '../../context/provider/ChatProvider';
import Wrapper from '../components/chat/Wrapper';
import { useChat } from '../../context/provider/ChatProvider';


export const Chat = () => {
    const { stateUser, signOut } = useContext(UserContext)
    const { socket, userName, setUserName, setCurrentRoom, currentRoom, connectionError } = useChat();


    useEffect(() => {
        // Verificar si el socket está definido y no está conectado
        if (socket && !socket.connected) {
            // Intentar conectarse al socket
            socket.connect();
        }

        // Manejar cualquier limpieza necesaria cuando el componente se desmonte
        return () => {
            // Verificar si el socket está definido y está conectado
            if (socket && socket.connected) {
                // Desconectar el socket
                socket.disconnect();
            }
        };
    }, [socket]); // Dependencia del efecto para volver a ejecutarlo si el socket cambia

  

    return (
        <> 
            {/* <GlobalStyle /> */}

            {/* <Background /> */}

            <ChatProvider>  
                <Wrapper />
            </ChatProvider>
 
        </> 
    )
}

